export enum NotificationType {
  Welcome = 'welcome',
  PasswordChanged = 'password_changed',
  IdentityApproved = 'identity_approved',
  IdentityRejected = 'identity_rejected',
  ProjectApproved = 'project_approved',
  ProjectRejected = 'project_rejected',
  ProjectSubmittedForReview = 'project_submitted_for_review',
  ProjectDeletedByAdmin = 'project_deleted_by_admin',
  ProjectCancelledBySp = 'project_cancelled_by_sp',
  ProjectDisputeRaisedByClient = 'project_dispute_raised_by_client',
  ClientProjectDisputeRaisedBySp = 'client_project_dispute_raised_by_sp',
  ProjectDeliverablesSubmitted = 'project_deliverables_submitted',
  ProjectDeliverablesUpdated = 'project_deliverables_updated',
  ProjectDeliverablesAccepted = 'project_deliverables_accepted',
  ProjectDeliverablesAutoApproved = 'project_deliverables_auto_approved',
  ProjectReported = 'report_item_reported_project',

  ProposalReceived = 'proposal_received',
  ProposalAccepted = 'proposal_accepted',
  ProposalNotSelected = 'proposal_not_selected',
  DailyProposalLimitReached = 'daily_proposal_limit_reached',

  ServiceApproved = 'service_approved',
  ServiceRejected = 'service_rejected',
  ServiceDeletedByAdmin = 'service_deleted_by_admin',
  ServiceSubmitted = 'service_submitted',

  ClientServiceRequestSent = 'client_service_request_sent',
  ServiceRequestReceived = 'service_request_received',
  ClientServiceRequestAccepted = 'client_service_request_accepted',
  ClientServiceRequestDeclined = 'client_service_request_declined',
  ClientServiceRequestAutoCancelled = 'client_service_request_auto_cancelled',
  ServiceRequestAutoCancelled = 'service_request_auto_cancelled',
  ClientServiceRequestCancelledBySp = 'client_service_request_cancelled_by_sp',
  ServiceRequestCancelledByClient = 'service_request_cancelled_by_client',

  ClientServiceRequestDisputeRaisedBySp = 'client_service_request_dispute_raised_by_sp',
  ServiceRequestDisputeRaisedByClient = 'service_request_dispute_raised_by_client',

  ServiceRequestDeliverablesSubmitted = 'service_request_deliverables_submitted',
  ServiceRequestDeliverablesAccepted = 'service_request_deliverables_accepted',
  ServiceRequestDeliverablesAutoApproved = 'service_request_deliverables_auto_approved',

  PortfolioApproved = 'portfolio_approved',
  PortfolioRejected = 'portfolio_rejected',
  PortfolioDeletedByAdmin = 'portfolio_deleted_by_admin',
  PortfolioSubmitted = 'portfolio_submitted',
  PortfolioReported = 'report_item_reported_portfolio',

  PostRejected = 'post_rejected',
  PostDeletedByAdmin = 'post_deleted_by_admin',

  CommentRejected = 'comment_rejected',
  CommentDeletedByAdmin = 'comment_deleted_by_admin',

  ProjectDisputeResolved = 'project_dispute_resolved',
  ServiceRequestDisputeResolved = 'service_request_dispute_resolved',

  PaymentReleased = 'payment_released',
  PaymentRefunded = 'payment_refunded',

  ServiceRequestReviewRequest = 'service_request_review_request',
  ProjectReviewRequest = 'project_review_request',
  ProjectReviewSubmitted = 'project_review_submitted',
  ServiceRequestReviewSubmitted = 'service_request_review_submitted',

  ProjectReportConfirmation = 'report_confirmation_project',
  ProjectReportNoViolation = 'report_no_violation_project',
  ProjectReportEditRequired = 'report_edit_required_project',
  ProjectReportPermanentRemoval = 'report_permanent_removal_project',

  ServiceReportConfirmation = 'report_confirmation_service',
  ServiceReportNoViolation = 'report_no_violation_service',
  ServiceReportEditRequired = 'report_edit_required_service',
  ServiceReportPermanentRemoval = 'report_permanent_removal_service',

  CommentReportConfirmation = 'report_confirmation_comment',
  CommentReportNoViolation = 'report_no_violation_comment',
  CommentReportEditRequired = 'report_edit_required_comment',
  CommentReportPermanentRemoval = 'report_permanent_removal_comment',

  PostReportConfirmation = 'report_confirmation_post',
  PostReportNoViolation = 'report_no_violation_post',
  PostReportEditRequired = 'report_edit_required_post',
  PostReportPermanentRemoval = 'report_permanent_removal_post',
}
